const periodRegex = /^(?!.*\.$)[^.].*[^.]$/;
const consecutivePeriodRegex = /(\.)\1+/;

const alphaNumRegex = /^[a-zA-Z0-9.]*$/;

const USERNAME_MIN_CHAR = 8;
export const USERNAME_MAX_CHAR = 16;

function checkCharacterCount(value = '', min = USERNAME_MIN_CHAR, max = USERNAME_MAX_CHAR) {
    return value.length >= min && value.length <= max;
}

export function validateUsername(username: string) {
    return [
        !checkCharacterCount(username) ? 'username_error_length' : '',
        !alphaNumRegex.test(username) ? 'username_error_alpha_numeric' : '',
        !periodRegex.test(username) ? 'username_error_pre_post_period' : '',
        consecutivePeriodRegex.test(username) ? 'username_error_consecutive_period' : '',
    ];
}
